const { IndexSubPackage } = require('./interface/indexClass');
const { UtilsSubPackage } = require('./interface/utilsClass');
const { SubgraphSubPackage } = require('./interface/subgraphClass');
const { MultipartyRageQuitSubPackage } = require('./interface/multipartyRageQuitClass');
const { CipSubPackage } = require('./interface/cipClass');
const { ConstantsSubPackage } = require('./interface/constantsClass');
const { ContractSubPackage } = require('./interface/contractClass');
const { BalanceReportingSubPackage } = require('./interface/balanceReportingClass');
const { WizardSubPackage } = require('./interface/lsdClass');

class StakehouseSDK extends IndexSubPackage {

    constructor(signer) {

        super(signer);
        
        this.utils = new UtilsSubPackage(signer);
        this.subgraph = new SubgraphSubPackage(signer);
        this.multipartyRageQuit = new MultipartyRageQuitSubPackage(signer);
        this.cip = new CipSubPackage(signer);
        this.balanceReport = new BalanceReportingSubPackage(signer);
        this.wizard = new WizardSubPackage(signer);

        this.constants = new ConstantsSubPackage(signer);
        this.contractInstance = new ContractSubPackage(signer);
    }
}

module.exports = {
    StakehouseSDK
};